import AboutNatio from "../components/User/AboutUs/AboutNatio/AboutNatio";
import CareerDetails from "../components/User/Career/CareerDetails";
import Career from "../screens/users/Career";
import ContactUs from "../screens/users/ContactUs";
import Home from "../screens/users/Home";
import ItSolution from "../screens/users/ItSolution";
import MainBlog from "../screens/users/MainBlog";
import ServiceDetails from "../screens/users/ServiceDetails";
import BlogDetail from "./../screens/users/BlogDetail";

export const userRoutes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aboutus",
    element: <AboutNatio />,
  },
  {
    path: "/career",
    element: <Career />,
  },
  {
    path: "/career-details/:id",
    element: <CareerDetails />,
  },
  {
    path: "/blog",
    element: <MainBlog />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetail />,
  },
  {
    path: "/contactus",
    element: <ContactUs />,
  },
  {
    path: "/service",
    children: [
      {
        path: ":id",
        element: <ServiceDetails />,
      },
    ],
  },
  {
    path: "/itsolutions",
    children: [
      {
        path: ":id",
        element: <ItSolution />,
      },
    ],
  },
];
